export const REDUCER_NAME="subscriptionPlanSlice"

export interface iSubscriptionPlanDTO {
    planName?: string;
    durationValue?: number;
    durationUnit?:string;
    price?: number;
    status?: boolean;
    description?:string;
  }
  
  export interface iSubscriptionPlanResponse {
    id: string;
    planName: string;
    durationUnit: string;
    durationValue:number;
    price: number;
    status: boolean;
    createdAt: string;
    updatedAt: string;
    description:string;
  }

  export interface iSubscriptionPlanMessageResponse {
    message: string;
  }

export interface iTrialActivation{
    remainingTime:number;
    isTrial:boolean
    isActive:number;
    inGrace?:boolean;
    locked?:boolean;
    graceEndsAt?:string | null;
    startDate:Date;
    data:{
      endDate:Date;
      planId?: string;
      planName?: string;
      durationValue?: number;
      durationUnit?: string;
      price?: number;
      autoRenewEnabled?: boolean;
      autoRenewAmount?: number;
      autoRenewNextChargeAt?: string | Date | null;
      autoRenewLastFailureReason?: string | null;
    }
  }

interface iTransactionDetails {
    transactionId: string;
    paymentTransactionId: string;
    amount: number;
    price?: number;
    transactionStatus: string;
    transactionDate: Date;
    paymentDetails: any; // JSON data, type adjust kar sakte hain if needed
  
    userId: string;
    userName: string;
    userEmail: string;
  
    planId: string;
    planName: string;
    planPrice: number;
    planDuration: string;
  
    subscriptionId: string;
    subscriptionStartDate: Date;
    subscriptionEndDate: Date;
    subscriptionStatus: boolean;
    subscriptionIsTrial: boolean;
  }

  export interface iverifyCouponCode{
    isValid:true
  }
  
  export interface iSubscriptionPlanState {
      isLoading: boolean;
      planList: iSubscriptionPlanResponse[];
      errorMessage: string | null;
      activationStatus:iTrialActivation;
      subscriberTransactionList:iTransactionDetails[];
      isVerifyCouponCode:iverifyCouponCode
    }
